import styled from 'styled-components';
import { palette } from 'styled-tools';

import { OptionalBackgroundButton } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Grid = styled(GridWrapper)`
	text-align: left;
	margin: 0;
`;

export const SorryText = styled.div`
	margin-top: 0;
	margin-bottom: 24px;
	p,
	ol > li {
		margin-bottom: 24px;
	}
	p,
	li {
		line-height: 150%;
	}

	div {
		text-decoration: underline;
		display: inline;
		cursor: pointer;
	}
`;

export const SorryButton = styled(OptionalBackgroundButton)`
	color: ${palette('white')};
	background: ${palette('gradientCalmBrand')};
	text-transform: capitalize;
`;

export const UnderlinedLink = styled.a`
	text-decoration: underline;
`;
